{
  "v4.documents1.adresse_invalide": "Adresse invalide : l’objet demandé est introuvable.",
  "v4.documents1.annuler": "Annuler",
  "v4.documents1.classement.aucun_element": "Aucun élément ne porte ce classement.",
  "v4.documents1.classement.confirmer": "Je confirme la suppression de « {{nom}} »",
  "v4.documents1.classement.couleur": "Couleur",
  "v4.documents1.classement.couleur_etiquette": "La couleur ne concerne que les étiquettes.",
  "v4.documents1.classement.couleurs.amber": "Ambre",
  "v4.documents1.classement.couleurs.blue": "Bleu",
  "v4.documents1.classement.couleurs.emerald": "Émeraude",
  "v4.documents1.classement.couleurs.pink": "Rose",
  "v4.documents1.classement.couleurs.red": "Rouge",
  "v4.documents1.classement.couleurs.slate": "Ardoise",
  "v4.documents1.classement.couleurs.violet": "Violet",
  "v4.documents1.classement.date_prevue": "Date prévue",
  "v4.documents1.classement.effet_confirmation": "La suppression demande une confirmation.",
  "v4.documents1.classement.effet_nombre": "{{n}} élément(s) perdront ce classement ; aucun élément n’est supprimé.",
  "v4.documents1.classement.elements": "Éléments rattachés",
  "v4.documents1.classement.enregistrer_libelle": "Enregistrer le libellé",
  "v4.documents1.classement.enregistrer_version": "Enregistrer la version cible",
  "v4.documents1.classement.libelle": "Libellé",
  "v4.documents1.classement.libelle_enregistre": "Libellé enregistré ; identité et rattachements conservés.",
  "v4.documents1.classement.libelle_requis": "Le libellé est obligatoire.",
  "v4.documents1.classement.livree": "Livrée",
  "v4.documents1.classement.nature": "Nature",
  "v4.documents1.classement.natures.composant": "Rubrique",
  "v4.documents1.classement.natures.etiquette": "Étiquette",
  "v4.documents1.classement.natures.version": "Version cible",
  "v4.documents1.classement.nom_version": "Nom de la version",
  "v4.documents1.classement.nombre": "Éléments rattachés : {{n}}",
  "v4.documents1.classement.non_livree": "Non livrée",
  "v4.documents1.classement.pas_preuve": "Marquer « livrée » ne vaut pas preuve de livraison.",
  "v4.documents1.classement.quoi": "le classement",
  "v4.documents1.classement.renommer": "Renommer",
  "v4.documents1.classement.renommer_version": "Une version cible se renomme dans sa section.",
  "v4.documents1.classement.retour": "Tout le classement du projet",
  "v4.documents1.classement.statut": "Statut",
  "v4.documents1.classement.suppression": "Suppression",
  "v4.documents1.classement.supprime": "Classement supprimé ; les éléments sont conservés.",
  "v4.documents1.classement.supprimer_etiquette": "Supprimer l’étiquette",
  "v4.documents1.classement.supprimer_rubrique": "Supprimer la rubrique",
  "v4.documents1.classement.supprimer_version_cible": "Supprimer la version cible",
  "v4.documents1.classement.titre": "Fiche de classement",
  "v4.documents1.classement.titre_objet.composant": "Rubrique — {{nom}}",
  "v4.documents1.classement.titre_objet.etiquette": "Étiquette — {{nom}}",
  "v4.documents1.classement.titre_objet.version": "Version cible — {{nom}}",
  "v4.documents1.classement.uniquement_version": "Réservé aux versions cibles.",
  "v4.documents1.classement.version_cible": "Version cible",
  "v4.documents1.classement.version_enregistree": "Version cible enregistrée.",
  "v4.documents1.code.AI_KILL_SWITCH_ACTIVE": "L’IA est arrêtée : le traitement ne part pas.",
  "v4.documents1.code.ALREADY_DECIDED": "Cette décision est déjà prise.",
  "v4.documents1.code.ALREADY_REVIEWED": "Une revue est déjà déposée sur cette version.",
  "v4.documents1.code.AMONT_CLASSEMENT_NOM_PRIS": "Ce nom est déjà pris dans le projet.",
  "v4.documents1.code.AMONT_DEROGATION_DEJA_DECIDEE": "La dérogation est déjà décidée : elle ne se retire plus.",
  "v4.documents1.code.AMONT_DOCUMENT_DEJA_PUBLIE": "Cette version est déjà publiée.",
  "v4.documents1.code.AMONT_DOCUMENT_NON_APPROUVE": "La version n’est pas approuvée : elle ne se publie pas.",
  "v4.documents1.code.AMONT_PREUVE_INCOMPATIBLE": "Cette preuve ne correspond pas à la version.",
  "v4.documents1.code.AMONT_PRODUCTION_INCONNUE": "Cette production n’existe pas dans le modèle du projet.",
  "v4.documents1.code.AMONT_PUBLICATION_AUTOMATIQUE": "Cette version est publiée automatiquement.",
  "v4.documents1.code.AMONT_RETRAIT_AUTEUR_SEUL": "Seul l’auteur de la sollicitation la retire.",
  "v4.documents1.code.AMONT_SOURCE_NON_APPROUVEE": "La source n’est pas approuvée.",
  "v4.documents1.code.AMONT_VERSION_NON_ABANDONNABLE": "Cette version ne s’abandonne pas (approuvée ou publiée).",
  "v4.documents1.code.APPROVAL_REQUIRES_INDEPENDENT_REVIEW": "Une revue indépendante est requise avant la décision.",
  "v4.documents1.code.CORE_UNAVAILABLE": "L’IA est arrêtée ou indisponible : le traitement ne part pas.",
  "v4.documents1.code.CREATEUR_N_APPROUVE_PAS": "La personne qui a créé ce document ne le décide pas : une autre personne le fait.",
  "v4.documents1.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour ce geste.",
  "v4.documents1.code.NOT_FOUND": "Objet introuvable dans ce projet.",
  "v4.documents1.code.POINT_DUPLICATE": "Cette question existe déjà sur ce document.",
  "v4.documents1.code.RELECTEUR_NE_DECIDE_PAS": "La personne qui a relu ce document ne le décide pas.",
  "v4.documents1.code.RESOURCE_UNAVAILABLE": "Cet objet n’existe pas ou n’est plus accessible dans ce projet.",
  "v4.documents1.code.RISK_APPROVAL_REQUIRES_JUSTIFICATION": "Une justification est requise pour ce verdict.",
  "v4.documents1.code.RISK_MITIGATION_REQUIRES_RISK_VERDICT": "Un plan de réduction suppose un verdict « risque ».",
  "v4.documents1.code.SPEC_CHANGE_ALREADY_OPEN": "Une proposition de révision est déjà ouverte sur ce document.",
  "v4.documents1.code.SPEC_CHANGE_NOT_FOUND": "Cette proposition de révision est introuvable dans le projet.",
  "v4.documents1.code.SPEC_GATE_EVIDENCE_UNAVAILABLE": "Les preuves ne sont pas disponibles pour cette version.",
  "v4.documents1.code.SPEC_NOT_PUBLISHED": "La spécification est approuvée mais pas encore publiée : la génération attend sa publication.",
  "v4.documents1.code.VALIDATION_ERROR": "Saisie refusée : vérifiez les champs obligatoires.",
  "v4.documents1.code.VALIDATION_PAR_UN_TIERS": "Une autre personne que l’auteur doit faire ce geste.",
  "v4.documents1.code.VERSION_CONFLICT": "Une autre version a été enregistrée entre-temps : rechargez avant de recommencer.",
  "v4.documents1.code.WAIVER_ALREADY_REVIEWED": "Cette dérogation a déjà été relue.",
  "v4.documents1.code.WAIVER_NOT_ACTIVE": "Cette dérogation n’est plus active (retirée ou close) : elle ne se relit ni ne se retire.",
  "v4.documents1.code_historique": "Code historique : {{code}}",
  "v4.documents1.confirmer.approuvee": "Version approuvée.",
  "v4.documents1.confirmer.approuver": "Confirmer l’approbation",
  "v4.documents1.confirmer.auteur": "Auteur : {{nom}}",
  "v4.documents1.confirmer.autre_personne": "L’auteur et la personne qui a relu ne décident pas.",
  "v4.documents1.confirmer.decidee_file": "Décision enregistrée depuis la file humaine.",
  "v4.documents1.confirmer.file": "Confirmer depuis la file humaine",
  "v4.documents1.confirmer.liee_version": "Votre attestation vaut pour la version {{n}} seulement.",
  "v4.documents1.confirmer.motif_requis": "Le motif est obligatoire pour rejeter.",
  "v4.documents1.confirmer.recapitulatif": "Récapitulatif",
  "v4.documents1.confirmer.rejetee": "Version rejetée.",
  "v4.documents1.confirmer.rejeter": "Confirmer le rejet",
  "v4.documents1.confirmer.relu_repris": "Contenu relu attesté pour cette version.",
  "v4.documents1.confirmer.revenir": "Revenir au document",
  "v4.documents1.confirmer.signature_enregistree": "Votre signature est enregistrée ; le document reste en attente ({{obtenues}} sur {{requises}}).",
  "v4.documents1.confirmer.titre": "Confirmer la décision",
  "v4.documents1.confirmer.verdict": "Verdict choisi : {{verdict}}",
  "v4.documents1.confirmer.verdicts.approved": "approuver",
  "v4.documents1.confirmer.verdicts.rejected": "rejeter",
  "v4.documents1.confirmer.version_modifiee": "La version a changé depuis votre relecture : relisez-la.",
  "v4.documents1.decision.approuver": "Approuver…",
  "v4.documents1.decision.commentaire": "Commentaire de décision",
  "v4.documents1.decision.commentaire_aide": "Obligatoire pour refuser.",
  "v4.documents1.decision.deja": "Décision déjà prise par {{par}}.",
  "v4.documents1.decision.refuser": "Refuser…",
  "v4.documents1.decision.relecture_requise": "Relisez le contenu de cette version avant de décider.",
  "v4.documents1.decision.relu": "J’ai relu le contenu de cette version",
  "v4.documents1.decisions.a_traiter": "À traiter",
  "v4.documents1.decisions.aucun_resultat": "Aucune décision ne correspond aux filtres.",
  "v4.documents1.decisions.deposer_entree": "Déposer une entrée",
  "v4.documents1.decisions.etat.approuvee": "Approuvée",
  "v4.documents1.decisions.etat.en_attente": "En attente",
  "v4.documents1.decisions.etat.rejetee": "Rejetée",
  "v4.documents1.decisions.etat.remplacee": "Remplacée",
  "v4.documents1.decisions.etat.toutes": "Toutes",
  "v4.documents1.decisions.filtre_entree": "Entrée d’origine",
  "v4.documents1.decisions.filtre_etape": "Étape",
  "v4.documents1.decisions.filtre_type": "Type de document",
  "v4.documents1.decisions.liste": "Décisions du projet",
  "v4.documents1.decisions.ouvrir": "Ouvrir {{titre}}",
  "v4.documents1.decisions.ouvrir_court": "Ouvrir",
  "v4.documents1.decisions.pour_moi": "Pour moi",
  "v4.documents1.decisions.pour_un_tiers": "Pour une autre personne",
  "v4.documents1.decisions.quoi": "les décisions",
  "v4.documents1.decisions.recherche": "Rechercher",
  "v4.documents1.decisions.retour_projet": "Retour au projet",
  "v4.documents1.decisions.sans_entree": "Sans entrée d’origine",
  "v4.documents1.decisions.titre": "Décisions à prendre",
  "v4.documents1.decisions.tous": "Tous",
  "v4.documents1.decisions.toutes": "Toutes",
  "v4.documents1.decisions.vide": "Aucune décision dans ce projet.",
  "v4.documents1.derogation.aucune_mesure": "Aucune mesure compensatoire.",
  "v4.documents1.derogation.auteur_requis": "Seul l’auteur de la sollicitation ({{nom}}) la retire, avant la décision.",
  "v4.documents1.derogation.avis": "Avis de relecture",
  "v4.documents1.derogation.avis_aide": "Dites si les mesures compensatoires suffisent.",
  "v4.documents1.derogation.avis_requis": "L’avis de relecture est obligatoire.",
  "v4.documents1.derogation.cible": "Cible",
  "v4.documents1.derogation.confirmer_retrait": "Je confirme le retrait de ma sollicitation",
  "v4.documents1.derogation.decision": "Décision",
  "v4.documents1.derogation.decision_organisation": "La décision appartient à l’organisation seulement.",
  "v4.documents1.derogation.defavorable": "Défavorable",
  "v4.documents1.derogation.demandeur": "Demandeur",
  "v4.documents1.derogation.demandeur_ne_tranche": "Le demandeur ne tranche jamais sa dérogation.",
  "v4.documents1.derogation.detail": "Détail à l’organisation",
  "v4.documents1.derogation.droit_non_herite": "Un droit du projet ne donne pas le droit de décider à l’organisation.",
  "v4.documents1.derogation.echeance": "Échéance",
  "v4.documents1.derogation.enregistrer_relecture": "Enregistrer la relecture",
  "v4.documents1.derogation.etat.a_decider_organisation": "Relue, à décider par l’organisation",
  "v4.documents1.derogation.etat.a_relire": "À relire",
  "v4.documents1.derogation.etat.accordee": "Accordée",
  "v4.documents1.derogation.etat.echue": "Échue",
  "v4.documents1.derogation.etat.levee": "Levée",
  "v4.documents1.derogation.etat.refusee": "Refusée",
  "v4.documents1.derogation.etat.retiree": "Retirée",
  "v4.documents1.derogation.evenement.decision": "Décision de l’organisation",
  "v4.documents1.derogation.evenement.demande": "Demande",
  "v4.documents1.derogation.evenement.fin_d_effet": "Fin d’effet",
  "v4.documents1.derogation.evenement.relecture": "Relecture",
  "v4.documents1.derogation.evenement.retrait": "Retrait",
  "v4.documents1.derogation.favorable": "Favorable",
  "v4.documents1.derogation.fiche": "Dérogation",
  "v4.documents1.derogation.historique": "Historique",
  "v4.documents1.derogation.mesures": "Mesures compensatoires",
  "v4.documents1.derogation.nature": "Nature",
  "v4.documents1.derogation.natures.charte": "Charte",
  "v4.documents1.derogation.natures.critere": "Critère",
  "v4.documents1.derogation.porteur": "Porteur",
  "v4.documents1.derogation.quoi": "la dérogation",
  "v4.documents1.derogation.relecture": "Relecture",
  "v4.documents1.derogation.relue": "Relecture enregistrée ; elle ne décide pas la dérogation.",
  "v4.documents1.derogation.retiree": "Sollicitation retirée.",
  "v4.documents1.derogation.retirer": "Retirer la sollicitation",
  "v4.documents1.derogation.retour": "Retour",
  "v4.documents1.derogation.retrait": "Retrait de la sollicitation",
  "v4.documents1.derogation.sans_echeance": "Sans échéance (autorisé)",
  "v4.documents1.derogation.suivre": "Suivre à l’organisation",
  "v4.documents1.derogation.surcharge": "Surcharge de la charte",
  "v4.documents1.derogation.titre": "Dérogation du projet",
  "v4.documents1.derogation.verdict": "Avis",
  "v4.documents1.design.apercus": "Aperçus",
  "v4.documents1.design.aucun_parcours": "Aucun parcours dans ce projet.",
  "v4.documents1.design.aucun_parcours_valide": "Aucun parcours validé.",
  "v4.documents1.design.aucun_test": "Aucun test d’usage prévu.",
  "v4.documents1.design.aucune_charte": "Aucune charte propre au projet.",
  "v4.documents1.design.aucune_comparaison": "Aucune comparaison.",
  "v4.documents1.design.charte_version": "Charte {{semver}} — {{etat}}",
  "v4.documents1.design.charte_visee": "Charte visée",
  "v4.documents1.design.chartes": "les chartes",
  "v4.documents1.design.comparaison_lancee": "Comparaison lancée.",
  "v4.documents1.design.comparaisons": "les comparaisons",
  "v4.documents1.design.comparer": "Comparer à la maquette",
  "v4.documents1.design.conformite": "la conformité",
  "v4.documents1.design.couple": "Comparaison du parcours version {{n}} à la révision {{revision}}.",
  "v4.documents1.design.critere": "Critère d’usage visé",
  "v4.documents1.design.document_source": "Document source",
  "v4.documents1.design.ecarts": "Écarts aux jetons : {{n}}",
  "v4.documents1.design.effective": "Charte effective : {{version}} ({{source}})",
  "v4.documents1.design.etat_flux.a_valider": "à valider",
  "v4.documents1.design.etat_flux.propose": "proposé",
  "v4.documents1.design.etat_flux.remplace": "remplacé",
  "v4.documents1.design.etat_flux.valide": "validé",
  "v4.documents1.design.heritage": "l’héritage de la charte",
  "v4.documents1.design.maquette_manquante": "Maquette manquante",
  "v4.documents1.design.onglet.charte": "Charte",
  "v4.documents1.design.onglet.conformite": "Conformité",
  "v4.documents1.design.onglet.parcours": "Parcours",
  "v4.documents1.design.onglet.tests_usage": "Tests d’usage",
  "v4.documents1.design.onglets": "Sections du design",
  "v4.documents1.design.ouvrir": "Ouvrir",
  "v4.documents1.design.ouvrir_charte": "Ouvrir la charte {{semver}}",
  "v4.documents1.design.ouvrir_parcours": "Ouvrir le parcours version {{n}}",
  "v4.documents1.design.par_defaut": "par défaut",
  "v4.documents1.design.parcours": "les parcours",
  "v4.documents1.design.parcours_a_comparer": "Parcours à comparer",
  "v4.documents1.design.parcours_version": "Parcours version {{n}} — {{etat}}",
  "v4.documents1.design.participants": "Participants (3 à 5)",
  "v4.documents1.design.preparer_charte": "Préparer une charte",
  "v4.documents1.design.prevoir": "Prévoir le test d’usage",
  "v4.documents1.design.profil": "Profil des participants",
  "v4.documents1.design.proposer": "Proposer un parcours",
  "v4.documents1.design.proposition_lancee": "Proposition lancée.",
  "v4.documents1.design.provenance_organisation": "Héritée de l’organisation.",
  "v4.documents1.design.releve_indisponible": "Relevé indisponible pour cette révision.",
  "v4.documents1.design.revision": "Révision réalisée",
  "v4.documents1.design.revision_requise": "Choisissez une révision pour voir sa conformité.",
  "v4.documents1.design.scenario": "Scénario",
  "v4.documents1.design.selection_incomplete": "Choisissez un parcours validé et une révision.",
  "v4.documents1.design.solliciter_surcharge": "Solliciter une surcharge",
  "v4.documents1.design.source.default": "par défaut",
  "v4.documents1.design.source.organisation": "organisation",
  "v4.documents1.design.source.override": "surchargée",
  "v4.documents1.design.source.project": "projet",
  "v4.documents1.design.surcharge_accordee": "Surcharge accordée.",
  "v4.documents1.design.surcharge_echue": "Surcharge échue : la charte de l’organisation s’applique de nouveau.",
  "v4.documents1.design.surcharge_en_attente": "Surcharge en attente.",
  "v4.documents1.design.taches": "Tâches (une par ligne, 1 à 10)",
  "v4.documents1.design.test_prevu": "Test d’usage prévu.",
  "v4.documents1.design.tests_usage": "les tests d’usage",
  "v4.documents1.design.titre": "Design du produit",
  "v4.documents1.design.titre_test": "Titre",
  "v4.documents1.design.version_validee": "Version validée {{n}}",
  "v4.documents1.document.abandon_ferme": "Abandon fermé : la version est approuvée.",
  "v4.documents1.document.abandon_masque": "Une version approuvée ou publiée ne s’abandonne pas.",
  "v4.documents1.document.abandonnee": "Version abandonnée ; elle reste dans l’historique.",
  "v4.documents1.document.abandonnee_mention": "abandonnée (conservée dans l’historique)",
  "v4.documents1.document.abandonner": "Abandonner la version {{n}}",
  "v4.documents1.document.ajouts": "Ajouts",
  "v4.documents1.document.aucune_difference": "Aucune différence entre ces versions.",
  "v4.documents1.document.auteur_approbateurs": "Auteur et approbateurs",
  "v4.documents1.document.changements": "Changements : {{n}}",
  "v4.documents1.document.choisir": "— Choisir —",
  "v4.documents1.document.choisir_deux": "Choisissez deux versions à comparer.",
  "v4.documents1.document.comprendre": "Comprendre et demander l’accès",
  "v4.documents1.document.confirmer_abandon": "Je confirme l’abandon ; la version reste dans l’historique",
  "v4.documents1.document.couverture": "Couverture",
  "v4.documents1.document.differences": "les différences",
  "v4.documents1.document.editer": "Éditer",
  "v4.documents1.document.empreinte_sortie": "Empreinte publiée",
  "v4.documents1.document.etat.approuve": "Approuvé",
  "v4.documents1.document.etat.aucune": "Aucune version courante",
  "v4.documents1.document.etat.brouillon": "Brouillon",
  "v4.documents1.document.etat.en_relecture": "En relecture",
  "v4.documents1.document.etat.publication_en_attente": "Publication en attente",
  "v4.documents1.document.etat.publication_en_echec": "Publication en échec",
  "v4.documents1.document.etat.publie": "Publié",
  "v4.documents1.document.etat.refuse": "Refusé",
  "v4.documents1.document.etat.remplace": "Remplacé",
  "v4.documents1.document.fiche": "Document",
  "v4.documents1.document.generer_elements": "Générer les éléments…",
  "v4.documents1.document.gestes": "Gestes",
  "v4.documents1.document.meme_version": "Choisissez deux versions distinctes.",
  "v4.documents1.document.non_publie": "Pas encore publié.",
  "v4.documents1.document.points_bloquants": "Points bloquants non vérifiés : {{n}}",
  "v4.documents1.document.preparer_mission": "Préparer une mission",
  "v4.documents1.document.preuve.fraiche": "Preuve fraîche.",
  "v4.documents1.document.preuve.perimee": "Preuve périmée : à réévaluer.",
  "v4.documents1.document.preuve.sans": "Aucune preuve rattachée.",
  "v4.documents1.document.proposer_revision": "Proposer une révision…",
  "v4.documents1.document.publication": "Publication",
  "v4.documents1.document.publiee": "Version publiée.",
  "v4.documents1.document.publier": "Publier la version {{n}}",
  "v4.documents1.document.quoi": "le document",
  "v4.documents1.document.raison.auteur_de_la_version": "L’auteur de la version ne la publie pas ; une autre personne le fait.",
  "v4.documents1.document.raison.deja_publie": "Cette version est déjà publiée.",
  "v4.documents1.document.raison.droit_non_tenu": "Vous ne tenez pas le droit de publier.",
  "v4.documents1.document.raison.non_approuve": "La version n’est pas approuvée.",
  "v4.documents1.document.raison.publication_automatique": "Cette version est publiée automatiquement.",
  "v4.documents1.document.reevaluee": "Preuve réévaluée.",
  "v4.documents1.document.reevaluer": "Réévaluer la preuve",
  "v4.documents1.document.reference_code": "Référence de code",
  "v4.documents1.document.reference_publication": "Référence de publication",
  "v4.documents1.document.retour_publies": "Documents publiés",
  "v4.documents1.document.retour_redaction": "Retour à la rédaction",
  "v4.documents1.document.retraits": "Retraits",
  "v4.documents1.document.suite_bloquee": "La suite (éléments, mission) attend la publication.",
  "v4.documents1.document.titre": "Document et versions",
  "v4.documents1.document.traiter_points": "Traiter les points",
  "v4.documents1.document.type": "Type du modèle",
  "v4.documents1.document.version_comparee": "Version comparée",
  "v4.documents1.document.version_depart": "Version de départ",
  "v4.documents1.document.versions": "Versions",
  "v4.documents1.document.voir_decision": "Voir la décision",
  "v4.documents1.ecran_non_realise": "« {{ecran}} » n’est pas encore disponible : cet écran arrive avec une vague ultérieure.",
  "v4.documents1.editeur.apercu": "Aperçu",
  "v4.documents1.editeur.aucune_reponse": "Aucune réponse à intégrer.",
  "v4.documents1.editeur.contenu": "Contenu du document",
  "v4.documents1.editeur.contenu_vide": "Le contenu est vide.",
  "v4.documents1.editeur.depart": "Version de départ",
  "v4.documents1.editeur.edition": "Édition",
  "v4.documents1.editeur.effet_approbation": "Aucune auto-approbation : une autre personne décide.",
  "v4.documents1.editeur.effet_conservee": "L’ancienne version reste dans l’historique.",
  "v4.documents1.editeur.effet_nouvelle": "La soumission crée une nouvelle version distincte.",
  "v4.documents1.editeur.effet_preuve": "La preuve sera recalculée sur la nouvelle version.",
  "v4.documents1.editeur.integration_a_verifier": "L’intégration sera vérifiée sur la nouvelle version.",
  "v4.documents1.editeur.lecture_seule": "Lecture seule : vous ne tenez pas le droit d’éditer.",
  "v4.documents1.editeur.motif": "Motif de la nouvelle version",
  "v4.documents1.editeur.non_enregistre": "Modifications non enregistrées.",
  "v4.documents1.editeur.perte_locale": "Vos modifications locales seront perdues.",
  "v4.documents1.editeur.reponses": "Réponses à intégrer",
  "v4.documents1.editeur.saisie": "Saisie",
  "v4.documents1.editeur.sans_document": "Choisissez un document à éditer depuis sa fiche.",
  "v4.documents1.editeur.soumettre": "Soumettre la nouvelle version",
  "v4.documents1.editeur.soumettre_autre": "Soumettre la nouvelle version du document",
  "v4.documents1.editeur.soumise": "Nouvelle version soumise ; elle attend la décision d’une autre personne.",
  "v4.documents1.editeur.titre": "Éditer un document",
  "v4.documents1.editeur.vers_decisions": "Voir les décisions",
  "v4.documents1.etat.chargement": "Chargement : {{quoi}}…",
  "v4.documents1.etat.en_cours": "En cours…",
  "v4.documents1.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v4.documents1.etat.introuvable": "Introuvable : {{quoi}}.",
  "v4.documents1.etat.reessayer": "Réessayer",
  "v4.documents1.etat.refus": "Accès refusé : {{quoi}}.",
  "v4.documents1.etat.vide": "Rien à afficher.",
  "v4.documents1.fiche.actualiser": "Actualiser la lecture",
  "v4.documents1.fiche.auteur": "Auteur",
  "v4.documents1.fiche.contenu": "Contenu du document",
  "v4.documents1.fiche.date": "Date",
  "v4.documents1.fiche.decider": "Décider",
  "v4.documents1.fiche.document": "Document",
  "v4.documents1.fiche.echanges": "Échanges de l’entrée",
  "v4.documents1.fiche.eligibilite": "Éligibilité et quorum",
  "v4.documents1.fiche.entree": "Entrée d’origine",
  "v4.documents1.fiche.lecture": "Mode de lecture",
  "v4.documents1.fiche.liens": "Liens",
  "v4.documents1.fiche.membres": "Membres du projet",
  "v4.documents1.fiche.mode.registre_technique": "Registre technique",
  "v4.documents1.fiche.mode.rendu": "Rendu",
  "v4.documents1.fiche.mode.texte_brut": "Texte brut",
  "v4.documents1.fiche.nouvelle_version": "Nouvelle version",
  "v4.documents1.fiche.points": "Points du document",
  "v4.documents1.fiche.preuves": "Preuves",
  "v4.documents1.fiche.quoi": "le document",
  "v4.documents1.fiche.remplacee": "remplacée",
  "v4.documents1.fiche.retour_decisions": "Retour aux décisions",
  "v4.documents1.fiche.retour_entree": "Entrée d’origine",
  "v4.documents1.fiche.revue": "Risque et revue",
  "v4.documents1.fiche.sans_entree": "Document sans entrée d’origine",
  "v4.documents1.fiche.source": "Source",
  "v4.documents1.fiche.source_absente": "Aucune source enregistrée",
  "v4.documents1.fiche.source_chargee": "Source chargée",
  "v4.documents1.fiche.titre": "Document et décision",
  "v4.documents1.fiche.traitements": "Traitements et productions",
  "v4.documents1.fiche.version": "Version",
  "v4.documents1.fiche.voir_document": "Voir le document et ses versions",
  "v4.documents1.generer.effet_acceptation": "Aucun élément n’est accepté automatiquement.",
  "v4.documents1.generer.effet_existants": "Les éléments déjà présents sont signalés, jamais écrasés.",
  "v4.documents1.generer.effet_niveaux": "Les niveaux créés sont ceux du modèle du projet.",
  "v4.documents1.generer.etat.document_approuve_et_publie": "Document approuvé et publié.",
  "v4.documents1.generer.etat.document_remplace": "Document remplacé par une version plus récente.",
  "v4.documents1.generer.etat.publication_non_terminee": "Publication non terminée : la génération attend.",
  "v4.documents1.generer.generer": "Générer les éléments",
  "v4.documents1.generer.lancee": "Génération lancée.",
  "v4.documents1.generer.preuve_fraiche": "Preuve fraîche.",
  "v4.documents1.generer.preuve_perimee": "Preuve périmée.",
  "v4.documents1.generer.provenance": "Provenance",
  "v4.documents1.generer.sans_preuve": "Aucune preuve.",
  "v4.documents1.generer.titre": "Générer les éléments",
  "v4.documents1.generer.version_empreinte": "Version {{n}} — empreinte {{empreinte}}",
  "v4.documents1.geste_echec": "Le geste n’a pas abouti. Réessayez ou consultez le journal.",
  "v4.documents1.points.ajoute": "Question ajoutée et sélectionnée.",
  "v4.documents1.points.ajouter": "Ajouter la question",
  "v4.documents1.points.aucune_selection": "Aucun point sélectionné.",
  "v4.documents1.points.bloquant": "bloquant",
  "v4.documents1.points.bloquant_non_atteste": "Point bloquant non attesté dans une version.",
  "v4.documents1.points.etat": "État : {{etat}}",
  "v4.documents1.points.fil.questions": "Questions ouvertes",
  "v4.documents1.points.fil.reponses_et_decisions": "Réponses et décisions",
  "v4.documents1.points.fil.tout": "Tout",
  "v4.documents1.points.fil.versions": "Versions",
  "v4.documents1.points.filtre": "Fil",
  "v4.documents1.points.question": "Nouvelle question",
  "v4.documents1.points.question_aide": "Rattachée à cette décision et à la version {{n}}.",
  "v4.documents1.points.question_requise": "La question est obligatoire.",
  "v4.documents1.points.reporter": "Tout reporter",
  "v4.documents1.points.reporter_effet": "{{n}} point(s) passent à « reporté » ; chacun se rouvre un par un, avec son historique.",
  "v4.documents1.points.reporter_n": "Reporter les {{n}} point(s) ouvert(s)",
  "v4.documents1.points.reporter_titre": "Reporter tous les points ouverts ?",
  "v4.documents1.points.reportes": "{{n}} point(s) reporté(s).",
  "v4.documents1.points.selectionner": "Sélectionner {{code}}",
  "v4.documents1.points.traiter": "Traiter le point",
  "v4.documents1.points.vide": "Aucun point sur ce document.",
  "v4.documents1.preuves.aucun_recu": "Aucun reçu d’évaluation.",
  "v4.documents1.preuves.comparer": "Comparer à l’extraction",
  "v4.documents1.preuves.evaluation_demandee": "Évaluation demandée.",
  "v4.documents1.preuves.evaluer": "Évaluer les preuves",
  "v4.documents1.preuves.fraiche_jusqu": "Preuve fraîche jusqu’au {{date}}",
  "v4.documents1.preuves.perimee_depuis": "Preuve périmée depuis le {{date}}",
  "v4.documents1.preuves.rattachee": "Preuve rattachée.",
  "v4.documents1.preuves.rattacher": "Rattacher la preuve",
  "v4.documents1.preuves.recu": "Reçu {{recu}}",
  "v4.documents1.preuves.reference": "Référence d’une preuve",
  "v4.documents1.preuves.reference_aide": "Rattachée à la version {{n}}.",
  "v4.documents1.preuves.reference_requise": "La référence de la preuve est obligatoire.",
  "v4.documents1.preuves.relues": "J’ai relu les preuves de la version {{n}}",
  "v4.documents1.preuves.renouvelee": "Preuve renouvelée.",
  "v4.documents1.preuves.renouveler": "Renouveler la preuve",
  "v4.documents1.preuves.score": "score {{score}}",
  "v4.documents1.preuves.statut": "Évaluation : {{statut}}",
  "v4.documents1.preuves.vide": "Aucune évaluation des preuves pour cette version.",
  "v4.documents1.production.acteurs": "Produire les acteurs",
  "v4.documents1.production.decomposer": "Décomposer en éléments…",
  "v4.documents1.production.document": "Produire le document suivant",
  "v4.documents1.production.examen_qualite": "Lancer un examen qualité",
  "v4.documents1.production.generer_version": "Générer une version",
  "v4.documents1.production.lancee": "Traitement lancé.",
  "v4.documents1.production.niveau_superieur": "Produire le niveau supérieur",
  "v4.documents1.production.nom_invalide": "Minuscules, chiffres et tirets ; commence par une lettre.",
  "v4.documents1.production.nom_technique": "Nom technique",
  "v4.documents1.production.options": "Produire les options",
  "v4.documents1.production.port": "Port d’écoute",
  "v4.documents1.production.port_invalide": "Un port entre 1024 et 65535.",
  "v4.documents1.production.processus": "Produire les processus",
  "v4.documents1.quorum.createur_ineligible": "Vous avez créé ce document : une autre personne le décide.",
  "v4.documents1.quorum.designe": "Signataire désigné par le modèle : {{nom}}",
  "v4.documents1.quorum.eligible": "Vous pouvez signer cette version.",
  "v4.documents1.quorum.raison.createur_n_approuve_pas": "Vous avez créé ce document : une autre personne le décide.",
  "v4.documents1.quorum.raison.deja_decidee": "Cette version est déjà décidée.",
  "v4.documents1.quorum.raison.deja_signee": "Vous avez déjà signé cette version.",
  "v4.documents1.quorum.signatures": "Signatures : {{obtenues}} sur {{requises}} requises par le modèle, {{restantes}} restante(s)",
  "v4.documents1.refus.createur_n_approuve_pas": "La personne qui a créé ce document ne le décide pas : une autre personne le fait.",
  "v4.documents1.refus.relecteur_ne_decide_pas": "La personne qui a relu ce document ne le décide pas.",
  "v4.documents1.refus.validation_par_un_tiers": "Une autre personne que l’auteur doit faire ce geste.",
  "v4.documents1.reviser.deja_ouverte": "Une proposition est déjà ouverte : {{ref}}.",
  "v4.documents1.reviser.immuable": "Cette version ne change pas : la révision en produira une nouvelle si elle est acceptée.",
  "v4.documents1.reviser.impact": "Impact",
  "v4.documents1.reviser.justification": "Justification",
  "v4.documents1.reviser.majeur": "Majeur",
  "v4.documents1.reviser.mineur": "Mineur",
  "v4.documents1.reviser.minimum": "Au moins 20 caractères.",
  "v4.documents1.reviser.note": "Note (facultative)",
  "v4.documents1.reviser.proposee": "Révision proposée.",
  "v4.documents1.reviser.proposer": "Proposer la révision",
  "v4.documents1.reviser.titre": "Proposer une révision",
  "v4.documents1.reviser.version_visee": "Version visée",
  "v4.documents1.revue.deja": "Revue déjà déposée : {{verdict}} par {{par}}.",
  "v4.documents1.revue.deposee": "Revue déposée ; elle ne vaut pas décision.",
  "v4.documents1.revue.deposer": "Déposer la revue",
  "v4.documents1.revue.justification": "Justification de la revue",
  "v4.documents1.revue.justification_requise": "La justification est obligatoire.",
  "v4.documents1.revue.verdict": "Verdict de la revue",
  "v4.documents1.revue.verdict_requis": "Choisissez un verdict.",
  "v4.documents1.revue.verdicts.approve": "Favorable",
  "v4.documents1.revue.verdicts.aucun": "— Choisir —",
  "v4.documents1.revue.verdicts.reject": "Défavorable",
  "v4.documents1.revue.verdicts.risk": "Risque",
  "v4.documents1.risque.categorie": "Catégorie de risque",
  "v4.documents1.risque.echeance": "Échéance",
  "v4.documents1.risque.enregistrer_plan": "Enregistrer le plan",
  "v4.documents1.risque.mesure": "Mesure de réduction",
  "v4.documents1.risque.niveau.aucun": "— Choisir —",
  "v4.documents1.risque.niveau.high": "Élevé",
  "v4.documents1.risque.niveau.low": "Faible",
  "v4.documents1.risque.niveau.medium": "Moyen",
  "v4.documents1.risque.plan_enregistre": "Plan de réduction enregistré.",
  "v4.documents1.risque.proprietaire": "Responsable de la mesure",
  "v4.documents1.risque.relevee": "Catégorie relevée.",
  "v4.documents1.risque.relever": "Relever la catégorie",
  "v4.documents1.sans_projet": "Aucun projet ouvert : choisissez-en un dans la barre de contexte.",
  "v4.documents1.titre_version": "{{titre}} — version {{n}}",
  "v4.documents1.traitements.etat.echec": "en échec",
  "v4.documents1.traitements.etat.en_cours": "en cours",
  "v4.documents1.traitements.etat.en_file": "en file",
  "v4.documents1.traitements.etat.termine": "terminé",
  "v4.documents1.traitements.quoi": "les traitements",
  "v4.documents1.traitements.vide": "Aucun traitement lancé depuis ce document.",
  "v4.documents1.version": "Version {{n}}",
  "v4.documents1.version_nouvelle.consigne": "Consigne pour la nouvelle version",
  "v4.documents1.version_nouvelle.consigne_aide": "Elle prépare l’entrée ; la nouvelle version repasse en décision.",
  "v4.documents1.version_nouvelle.consigne_requise": "Donnez une consigne ou choisissez au moins une réponse.",
  "v4.documents1.version_nouvelle.editer": "Éditer le document",
  "v4.documents1.version_nouvelle.entree_requise": "Ce document n’a pas d’entrée d’origine : une nouvelle version ne se sollicite pas ici.",
  "v4.documents1.version_nouvelle.sollicitee": "Nouvelle version {{n}} sollicitée.",
  "v4.documents1.version_nouvelle.solliciter": "Solliciter une nouvelle version",
  "v4.documents1.version_nouvelle.transmettre": "Transmettre la réponse {{code}}"
}
